class PromoCountdownBar extends HTMLElement {
  constructor() {
    super();
    this.onScrollHandler = this.onScroll.bind(this);
    this.tickHandler = this.tick.bind(this);
    this.currentScrollTop = 0;
    this.scrollThreshold = 20;
    this.intervalId = null;
  }

  connectedCallback() {
    this.section = this.closest('.promo-countdown-bar-section');
    this.daysEl = this.querySelector('[data-countdown-days]');
    this.hoursEl = this.querySelector('[data-countdown-hours]');
    this.minutesEl = this.querySelector('[data-countdown-minutes]');
    this.secondsEl = this.querySelector('[data-countdown-seconds]');

    this.readEndTime();
    this.hideWhenExpired = this.dataset.hideWhenExpired === 'true';
    this.hideOnScroll = this.dataset.hideOnScroll === 'true';
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.startTimer();

    if (this.hideOnScroll) {
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }
  }

  readEndTime() {
    this.endTime = Date.parse(this.dataset.countdownEnd || '');
  }

  startTimer() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
    }

    this.tick();
    this.intervalId = window.setInterval(this.tickHandler, 1000);
  }

  disconnectedCallback() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
    }

    window.removeEventListener('scroll', this.onScrollHandler);
  }

  pad(value) {
    return String(value).padStart(2, '0');
  }

  setCountdownValues(days, hours, minutes, seconds) {
    if (this.daysEl) this.daysEl.textContent = this.pad(days);
    if (this.hoursEl) this.hoursEl.textContent = this.pad(hours);
    if (this.minutesEl) this.minutesEl.textContent = this.pad(minutes);
    if (this.secondsEl) this.secondsEl.textContent = this.pad(seconds);
  }

  tick() {
    if (Number.isNaN(this.endTime)) {
      this.setCountdownValues(0, 0, 0, 0);
      return;
    }

    const remainingMs = this.endTime - Date.now();

    if (remainingMs <= 0) {
      this.setCountdownValues(0, 0, 0, 0);

      if (this.hideWhenExpired) {
        this.collapse();
      }

      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }

      return;
    }

    const totalSeconds = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.setCountdownValues(days, hours, minutes, seconds);
  }

  collapse() {
    if (this.section) {
      this.section.classList.add('is-collapsed');
    }
  }

  expand() {
    if (this.section) {
      this.section.classList.remove('is-collapsed');
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop <= this.scrollThreshold) {
      this.expand();
    } else if (scrollTop > this.currentScrollTop && scrollTop > this.scrollThreshold) {
      this.collapse();
    }

    this.currentScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }
}

if (!customElements.get('promo-countdown-bar')) {
  customElements.define('promo-countdown-bar', PromoCountdownBar);
}

document.addEventListener('shopify:section:load', (event) => {
  const bar = event.target.querySelector('promo-countdown-bar');
  if (!bar) return;

  bar.readEndTime();
  bar.startTimer();
});
